import api from "../api";

export async function uploadFormFile(formId, fieldId, file) {
  const { data } = await api.post("/forms/upload-url", { form_id: formId, field_id: fieldId, filename: file.name });
  const res = await fetch(data.upload_url, {
    method: "PUT",
    headers: { "content-type": file.type || "application/octet-stream", "x-upsert": "true" },
    body: file,
  });
  if (!res.ok) {
    const t = await res.text().catch(() => "");
    throw new Error(`Upload failed (${res.status}). ${t}`);
  }
  return { name: data.name, path: data.path };
}
